import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import api from '../../services/api';
import { FormatarData, MeioPagamento } from '../../utils/Utils';
import Logo from '../../assets/logo.png';
import { LandscapeOrientation } from '../../utils/landscapeOrientation';

function ComissoesBaixadas() {
  let { dataInicial, dataFinal } = useParams();
  const [relatorio, setRelatorio] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const url = `/RelatorioPedidos/comissoesBaixadas/${dataInicial}/${dataFinal}`;
      const response = await api.get(url);
      setRelatorio(response ? response.data : []);
    }
    fetchData();
  }, [dataInicial, dataFinal]);

  const linhas = (relatorio || []).filter(l => !!l.DataBaixa);

  const totalComissao = linhas.reduce((acc, v) => acc + (Number(v.ValorComissaoTotal) || 0), 0);

  return (
    <div style={{ width: '100%', paddingLeft: 15, paddingRight: 15 }}>
      <LandscapeOrientation />
      <div style={{ fontSize: 12 }} className="row pr-3 pl-3 pt-3">
        <div style={{ width: 150 }}>
          <img className='logo' src={Logo} alt="Logo" />
        </div>
        <div className="pl-2">
          <b>Relatório de Comissões Baixadas</b><br />
          De {<FormatarData data={dataInicial} />} até {<FormatarData data={dataFinal} />}
        </div>
      </div>
      <div className="relatorio table-responsive mt-2" style={{ overflowX: 'auto' }}>
        <table
          style={{
            width: '100%',
            minWidth: 900,
            borderCollapse: 'collapse',
          }}
          cellPadding="6"
          className="table table-striped"
        >
          <thead>
            <tr style={{ background: '#f1f1f1' }}>
              <th style={{ whiteSpace: 'nowrap' }}>Pedido</th>
              <th style={{ minWidth: 200 }}>Fornecedor</th>
              <th style={{ minWidth: 150 }}>Cliente</th>
              <th style={{ whiteSpace: 'nowrap' }}>Data da Baixa</th>
              <th style={{ whiteSpace: 'nowrap', textAlign: "right" }}>Valor Total da Comissão</th>
              <th style={{ whiteSpace: 'nowrap' }}>Meio de Pagamento</th>
            </tr>
          </thead>
          <tbody>
            {relatorio.map((linha, index) => (
              <tr key={index} style={{ fontSize: 12 }}>
                <td>{linha.Numero}</td>
                <td>{linha.Fornecedor}</td>
                <td>{linha.Cliente}</td>
                <td>{<FormatarData data={linha.DataBaixa} />}</td>
                <td style={{ textAlign: "right" }}>
                  {linha.ValorBaixado?.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
                </td>
                <td><MeioPagamento meio={linha.MeioPagamento} /></td>
              </tr>
            ))}
            <tr style={{ fontWeight: "bold" }}>
              <td colSpan="4">Total</td>
              <td style={{ textAlign: "right" }}>
                {relatorio.reduce((a, v) => a + v.ValorBaixado, 0).toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </td>
              <td></td>
            </tr>
             {linhas.length === 0 && (
              <tr>
                <td colSpan="6" style={{ textAlign: 'center', fontStyle: 'italic', fontWeight: 'bold' }}>
                  Nenhum pedido baixado no período.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ComissoesBaixadas;